<template>
  <div
    class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
  >
    <div class="bg-base-100 p-6 rounded-lg shadow-lg max-w-md w-full">
      <h4 class="text-lg font-semibold mb-4">Remove Noise Settings</h4>
      <div class="space-y-4">
        <div class="space-y-2">
          <label class="font-medium text-base-content"
            >Neighbor Threshold (1-100):</label
          >
          <input
            type="range"
            v-model.number="threshold"
            min="1"
            max="100"
            class="range range-primary w-full"
          />
          <div class="text-center font-medium text-primary">
            Current: {{ threshold }}%
          </div>
          <div class="text-sm text-base-content/70 mt-2 leading-relaxed">
            Lower values (1-30): Conservative, preserves more details<br />
            Medium values (31-70): Balanced noise removal<br />
            Higher values (71-100): Aggressive noise removal, may affect details
          </div>
        </div>
      </div>
      <div class="flex justify-end gap-4 mt-4">
        <button @click="confirmRemoval" class="btn btn-primary">Confirm</button>
        <button @click="$emit('close')" class="btn">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits<{
  (e: "remove-noise", threshold: number): void;
  (e: "close"): void;
}>();

const threshold = ref(50);

const confirmRemoval = () => {
  if (threshold.value < 1 || threshold.value > 100) {
    alert("Please enter a threshold between 1 and 100");
    return;
  }
  emit("remove-noise", threshold.value);
};
</script>
